import React, { useEffect } from 'react';
import { Banner } from '@els/els-react--banner';
import { ButtonWithIcon } from '@els/els-react--button';
import { trackSummaryNotAvailable } from '@Containers/Summary/analytics';

function SummaryNotAvailable({ toggleHowItWorksPanel }) {
  useEffect(() => {
    trackSummaryNotAvailable();
  }, []);

  return (
    <div className="ai-search-summary__not-available" data-testid="summary-not-available">
      <ButtonWithIcon
        type="link"
        linkIconSize="xs"
        sprite="InformationOutlineCircle"
        iconRight
        className="u-els-margin-bottom"
        data-e2e="search-tips-button"
        onClick={toggleHowItWorksPanel}>
        Learn how it works
      </ButtonWithIcon>
      <Banner type="alert" isVisible>
        The summary no longer match the filtered results. To restore it, return to your original search or remove the applied filters.
      </Banner>
    </div>
  );
}

export default SummaryNotAvailable;
